module.exports = __webpack_public_path__ + "img/alexander.78d9c1c8.png";